import { SurveyInformation } from './survey-information.model';

export class SurveyInformationMapper {
  public static map(surveyData: any): SurveyInformation {
    if (!surveyData) {
      return null;
    }

    return new SurveyInformation(
        surveyData.id,
        surveyData.name,
        surveyData.type,
        surveyData.surveyStartDate,
        surveyData.surveyEndDate,
        surveyData.questionsPerPage,
        surveyData.reanswerEnabled,
        surveyData.isStarted,
        surveyData.currentPageNumber,
        surveyData.totalPages,
        surveyData.sessionStatus
      );
  }
}



// WEBPACK FOOTER //
// /dist/src/app/survey/fill-out-the-questionnaire/survey-information.mapper.ts